<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchName" size="small" class="input-with-select">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.voteStatus" placeholder="请选择" size="small">
                        <el-option label="不限制投票状态" :value="0"></el-option>
                        <el-option label="仅看未开始的" :value="1"></el-option>
                        <el-option label="仅看投票中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/vote/indieStar/update')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.voteEdit.show()">创建投票</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-row :gutter="40">
                            <el-col v-for="(item,index) in props.row.performerInfos" :key="index" class="MT10">
                                {{item.name}} : {{item.num}}票
                            </el-col>
                            <el-col class="MT10">
                                投票URL: {{`${sswap}/pages/special/indiestar/vote2/vote2?id=${props.row.id}`}}
                                <el-button size="mini" type="text" icon="el-icon-copy-document" @click="copy(props.row.id)">复制</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="投票ID"></el-table-column>
                <el-table-column prop="activityId" label="关联演出ID" min-width="90"></el-table-column>
                <el-table-column prop="activityName" label="关联演出名称" show-overflow-tooltip min-width="200"></el-table-column>
                <el-table-column prop="activityStartTime" label="首场开演时间" min-width="150"></el-table-column>
                <el-table-column prop="performerInfos" label="关联乐队" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip placement="top">
                            <div slot="content">
                                <div v-for="(item,index) in scope.row.performerInfos" :key="index" class="performerInfos-item">{{item.name}} : {{item.num}}票</div>
                            </div>
                            <span class="ellipsis">{{scope.row.performerInfos.map(v => v.name).toString()}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="cityName" label="演出城市"></el-table-column>
                <el-table-column label="投票时间段" width="200">
                    <template slot-scope="scope">
                        <p>起：{{scope.row.voteStartTime}}</p>
                        <p>止：{{scope.row.voteEndTime}}</p>
                    </template>            
                </el-table-column>
                <el-table-column label="投票状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">未开始</span>
                        <span v-else-if="scope.row.status == 2" class="color-success">投票中</span>
                        <span v-else-if="scope.row.status == 3" class="color-info">已结束</span>
                    </template>            
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" icon="el-icon-copy-document" @click="copy(scope.row.id)">复制链接</el-button>
                        <el-button
                            v-if="$utils.have('/vote/indieStar/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="$refs.voteEdit.show(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/vote/indieStar/del')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>    
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <input class="copyTool" ref="copyTool" :value="copyText" />
        <Edit ref="voteEdit" @onUpdate="getDataList"></Edit>
    </div>
</template>
<script>
import Edit from './components/edit';
const defaultParams = {
    pageNo:1,
    searchType:1,
    searchName:"",
    voteStatus:0
}
export default {
    components:{Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: false,    
            sswap: process.env.VUE_APP_SSWAP_URL,
            copyText:'',
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/vote/indieStar/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //复制链接
        copy(id){
            this.copyText = `${this.sswap}/pages/special/indiestar/vote2/vote2?id=${id}`;
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
        del(id){
            this.$confirm('删除后不可恢复，确定要删除吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/vote/indieStar/del",
                    method: "POST",
                    params: {id:id},
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("操作失败");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            }).catch(() => {})
        },
    }
}
</script>

<style scoped lang="scss">
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
.performerInfos-item{
    margin: 6px 0;
}
</style>